export const BASE_URL = process.env.REACT_APP_BASEAPI_URL;
export const API_V5 = process.env.REACT_APP_API_V5 ?? "v5/";
export const API_V51 = process.env.REACT_APP_API_V51 ?? "v5.1/";
export const API_V6 = process.env.REACT_APP_API_V6 ?? "v6/";
export const DEFAULT_API_VERSION =
  process.env.REACT_APP_DEFAULT_API_VERSION ?? API_V5;
export const SCHEDULE_API_VERSION =
  process.env.REACT_APP_SCHEDULE_API_VERSION ?? API_V51;
export const MCP_API_VERSION =
  process.env.REACT_APP_MCP_API_VERSION ?? API_V6;

// LoginAPI Endpoints
export const GetLoginById_url = `${DEFAULT_API_VERSION}ReactLogin_api`;
export const GetLoginByIdPassword_url = `${DEFAULT_API_VERSION}User/validation`;
export const ManualLogin_url = `${DEFAULT_API_VERSION}User/login`;
export const RedirectToUrl = `${DEFAULT_API_VERSION}User/selectLgnRegMethod`;
export const Register_url = `${DEFAULT_API_VERSION}User/register`;
export const ForgotPassword_url = `${DEFAULT_API_VERSION}User/forgotPassword`;
export const ResetPassword_url = `${DEFAULT_API_VERSION}User/resetPassword`;
export const validateResetPasswordToken_url = `${DEFAULT_API_VERSION}User/validateResetPasswordToken`;
export const validateRegisterConfirmation_url = `${DEFAULT_API_VERSION}User/verifyUser`;
export const originMismatch_url = `${DEFAULT_API_VERSION}access_denied/origin_mismatch`;
export const CheckUserVehicle_url = `${DEFAULT_API_VERSION}CheckUserVehicle_api`;

export const UserLogout_url = `${DEFAULT_API_VERSION}UserLogout_api`;
// Token API Endpoint
export const GetRefreshToken_api = `${DEFAULT_API_VERSION}Token_api`;

// Weekly-Calendar API Endpoints
export const GetWeeklyCalendar_url = `${API_V6}MyWeeklyBookings_api`;
export const ZoneList_url = `${DEFAULT_API_VERSION}ZoneList_api`;
export const MakeBooking_url = `${SCHEDULE_API_VERSION}MakeBooking_api`;
export const CancelBooking_url = `${DEFAULT_API_VERSION}CancelBooking_api`;
export const MapGrid_api = `${API_V6}MapGrid_api`;
export const MapCanvas_api = `${API_V6}MapCanvas_api`;
export const GetParticipantsForMeeting_url = `${DEFAULT_API_VERSION}MeetingRoom_api/GetParticipantsForMeeting`;
export const RescheduleMeeting_url = `${DEFAULT_API_VERSION}MeetingRoom_api/RescheduleMeeting`;
export const MeetingRoomListAndInfo_url = `${DEFAULT_API_VERSION}MeetingRoom_api/MeetingRoomListAndInfo`;
// Pinned to v6 so it doesn't follow DEFAULT_API_VERSION.
export const MeetingRoomsAvailableAndBookings_url = `${API_V6}MeetingRoom_api/MeetingRoomsAvailableAndBookings`;
// v5.1 (RONLARAVEL-21): request takes RepeatInterval + MonthlyRepeatType and no
// longer takes MonthlyRepeatOption. EditMeeting_url below is already v5.1.
export const CreateNewMeeting_url = `${SCHEDULE_API_VERSION}MeetingRoom_api/CreateNewMeeting`;
export const EditMeeting_url = `${SCHEDULE_API_VERSION}EditMeeting_api`;
export const ReportParkingViolation_url = `${API_V6}ReportParkingViolation_api`;
export const GetAlternateParkingSpot_url = `${API_V6}GetAlternateParkingSpot_api`;
export const CancelMeeting_url = `${DEFAULT_API_VERSION}MeetingRoom_api/CancelMeeting`;
export const DeclineMeeting_url = `${DEFAULT_API_VERSION}MeetingRoom_api/DeclineMeeting`;

// Notification API Endpoints
export const NotificationList_url = `${DEFAULT_API_VERSION}NotificationList_api`;
export const NotificationToggleStatus_url = `${DEFAULT_API_VERSION}NotificationToggleStatus_api`;
export const CheckInUser_url = `${DEFAULT_API_VERSION}CheckInUser_api`;
export const MarkAsReadNotification_url = `${DEFAULT_API_VERSION}MarkAsReadNotification_api`;
export const BookingConfirmation_url = `${DEFAULT_API_VERSION}BookingConfirmation_api`;
export const ScheduledBookingConfirmation_url = `${DEFAULT_API_VERSION}ScheduledBookingConfirmation_api`;
export const BookingStatus_url = `${DEFAULT_API_VERSION}MakeBooking_api/BookingStatus`;

// Post-Booking Question API Endpoints
export const PostBookingQuestion_url = `${DEFAULT_API_VERSION}PostBookingQuestion_api`;
export const PostBookingAnswer_url = `${DEFAULT_API_VERSION}PostBookingAnswer_api`;
export const MapBasedBooking_apiBookingStatus_url = `${SCHEDULE_API_VERSION}MapBasedBooking_api/BookingStatus`;

// Home > My Bookings API Endpoints
export const HomeScreenBookings_url = `${DEFAULT_API_VERSION}HomeScreenBookings_api`;
export const SearchBookings_url = `${DEFAULT_API_VERSION}SearchBookings_api`;

// Home > My Inviatations API Endpoints
export const InvitationGuestBookings_url = `${DEFAULT_API_VERSION}InvitationGuestBookings_api`;
export const CheckInForGuestUser_url = `${DEFAULT_API_VERSION}CheckInForGuestUser_api`;
export const ReportParkingViolationForGuest_url = `${API_V6}ReportParkingViolationForGuest_api`;
export const GetAlternateParkingSpotForGuest_url = `${API_V6}GetAlternateParkingSpotForGuest_api`;

// Create New Booking API Endpoints
export const QuickBookingInfo_url = `${DEFAULT_API_VERSION}QuickBookingInfo_api`;
export const SpotAvailability_url = `${DEFAULT_API_VERSION}SpotAvailability_api`;
export const MapBasedBooking_url = `${DEFAULT_API_VERSION}MapBasedBooking_api`;

// Profile API Endpoints
export const Profile_url = `${DEFAULT_API_VERSION}Profile_api`;

// Setting > Need help? API Endpoints
export const Support_url = `${DEFAULT_API_VERSION}Support_api`;

// Setting > Remove account API Endpoint
export const RemoveAccount_url = `${DEFAULT_API_VERSION}User/removeAccount`;

// Reception dashboard (RON-5469). Laravel VCM, v6 — the contract is
// `docs/RON-5460/RON-5460_frontend-reception.md` in the laravel-migration repo (read-only).
//
// `API_V6` and `BASE_URL` come from the environment, so nothing here pins a host: staging is
// already `https://apistaging.ronspot.io/api/` in `.env`.
export const ReceptionBoard_url = `${API_V6}visitor/reception/board`;
export const ReceptionSites_url = `${API_V6}visitor/reception/sites`;
// §4b, added 29-September-2026. THE ONE RECEPTION ENDPOINT WITHOUT `site_id`, deliberately: it
// IS the switcher, whose job is to compare sites, so the company is the scope. It returns two
// numbers per site and never a person, a name or a row, so there is no list anybody could
// mistake for a muster — which is the reason every other call is pinned to one site.
export const ReceptionSiteCounts_url = `${API_V6}visitor/reception/site-counts`;
export const ReceptionHosts_url = `${API_V6}visitor/reception/hosts`;
export const ReceptionWalkIns_url = `${API_V6}visitor/reception/walk-ins`;
export const ReceptionUnlock_url = `${API_V6}visitor/reception/unlock`;

// The four visit-scoped writes (§6, §7). Functions rather than constants because the visit id is
// in the PATH, not the body — building these by hand at each call site is how one ends up with a
// stray slash or an unencoded id.
export const ReceptionCheckIn_url = (visitId) =>
  `${API_V6}visitor/reception/visits/${encodeURIComponent(visitId)}/check-in`;
export const ReceptionCheckOut_url = (visitId) =>
  `${API_V6}visitor/reception/visits/${encodeURIComponent(visitId)}/check-out`;
export const ReceptionVip_url = (visitId) =>
  `${API_V6}visitor/reception/visits/${encodeURIComponent(visitId)}/vip`;
export const ReceptionNotifyHost_url = (visitId) =>
  `${API_V6}visitor/reception/visits/${encodeURIComponent(visitId)}/notify-host`;

// Un-vetted contractor approval — Phase H, shipped 22-October-2026.
//
// These replace `ReceptionApproveEntry_url` / `ReceptionDenyEntry_url`, which were OURS: we
// proposed `visits/{id}/approve-entry` and the real endpoints are `entry-approvals/{id}/approve`.
// The id is the APPROVAL's, not the visit's — a visit can raise more than one request over a day
// and the approval row is what carries the decision.
//
// `site_id` travels as a QUERY parameter on both, not in the body, which is how the contract
// writes them.
export const ReceptionEntryApprovals_url = `${API_V6}visitor/reception/entry-approvals`;
export const ReceptionEntryApprovalApprove_url = (approvalId) =>
  `${API_V6}visitor/reception/entry-approvals/${encodeURIComponent(approvalId)}/approve`;
export const ReceptionEntryApprovalDeny_url = (approvalId) =>
  `${API_V6}visitor/reception/entry-approvals/${encodeURIComponent(approvalId)}/deny`;

// ── Visitor invite portal (RON-5466 / RON-6002) ──────────────────────────────────────────────
//
// The employee-facing half of VCM: "my own invitations". The contract is
// `docs/RON-5460/RON-6002/RON-6002_api-employee-invite.md` in laravel-migration (read-only).
//
// Everything is scoped to the caller as HOST, by the token — there is no `user_id` parameter and
// no way to ask for somebody else's. A COLLEAGUE'S BOOKING ANSWERS 404, NOT 403, deliberately:
// a 403 would confirm the id exists, which leaks between colleagues and between companies. So a
// 404 here is not necessarily a bug.
export const VisitorHostPermissions_url = `${API_V6}visitor/me/host-permissions`;
export const VisitorSites_url = `${API_V6}visitor/me/sites`;
export const VisitorContractors_url = `${API_V6}visitor/me/contractors`;
export const VisitorVisits_url = `${API_V6}visitor/me/visits`;
// §4.10, added 29-October-2026. "Request vetting" — the host cannot book this contractor, so asks
// the compliance admin team. Needs `can_contractor`, and takes an `Idempotency-Key`.
export const VisitorVettingRequests_url = `${API_V6}visitor/me/vetting-requests`;

// Visit-scoped, so the id is in the path. Functions rather than constants, for the same reason as
// the reception writes: building these by hand at each call site is how a stray slash or an
// unencoded id gets in.
export const VisitorVisit_url = (visitId) =>
  `${API_V6}visitor/me/visits/${encodeURIComponent(visitId)}`;
export const VisitorVisitCancel_url = (visitId) =>
  `${API_V6}visitor/me/visits/${encodeURIComponent(visitId)}/cancel`;
// A GROUP is one invitation that created several visits — the id of the invite, not of a person.
export const VisitorGroupCancel_url = (groupId) =>
  `${API_V6}visitor/me/visit-groups/${encodeURIComponent(groupId)}/cancel`;

// ── Contractor compliance portal (RON-5465) ──────────────────────────────────────────────────
//
// THESE ARE THE ONLY ENDPOINTS IN THIS FILE WITH NO RONSPOT LOGIN BEHIND THEM. The caller is a
// contractor from another company who arrived from an email, and the session is an
// `X-Portal-Token` — never an `Authorization` bearer. `PortalAPI.jsx` therefore does its own
// fetching and must not import the shared `post()`, which would attach the signed-in employee's
// token to a page anyone holding a link can open.
//
// THE TOKEN NEVER APPEARS IN A URL — Phase A, 21-October-2026. The contract is explicit:
// "the portal page reads the token from its own URL and sends it in the BODY of `open`,
// `request-code` and `verify-code`. Never put it in an API URL."
//
// These three took the pack guid in the path until 22-October. The replacement is a 43-character
// token that carries no ids, and the move to the body is a real improvement rather than a
// rename: a path reaches access logs, proxies, and the `Referer` of every third-party request
// the page makes — and this page makes one, the embedded map.
//
// The token identifies WHICH pack; the emailed code proves WHO. It is not a credential on its
// own, but unlike the guid it DOES expire, and a newer link closes it.
export const PortalOpen_url = `${API_V6}visitor/portal/open`;
export const PortalRequestCode_url = `${API_V6}visitor/portal/request-code`;
export const PortalVerifyCode_url = `${API_V6}visitor/portal/verify-code`;

// Everything below is scoped by the session token, not the guid — the server knows whose pack it
// is once you are signed in, and taking the guid again would let a signed-in session ask about
// somebody else's.
export const PortalPack_url = `${API_V6}visitor/portal/pack`;
export const PortalSubmit_url = `${API_V6}visitor/portal/submit`;
export const PortalPersonnelConfirm_url = `${API_V6}visitor/portal/personnel/confirm`;
export const PortalSignOut_url = `${API_V6}visitor/portal/sign-out`;

export const PortalDocument_url = (documentId) =>
  `${API_V6}visitor/portal/documents/${encodeURIComponent(documentId)}`;
export const PortalDocumentSign_url = (documentId) =>
  `${API_V6}visitor/portal/documents/${encodeURIComponent(documentId)}/sign`;
export const PortalDocumentUploadUrl_url = (documentId) =>
  `${API_V6}visitor/portal/documents/${encodeURIComponent(documentId)}/upload-url`;
export const PortalDocumentUploaded_url = (documentId) =>
  `${API_V6}visitor/portal/documents/${encodeURIComponent(documentId)}/uploaded`;
